

import Vue from 'vue'
import App from './App'
import Moment from 'moment'
import FastClick from 'fastclick'
import router from './router'
import store from './store'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

import 'lib-flexible'
import './assets/css/app.scss'

Vue.use(LoadingPlugin)
Vue.use(ToastPlugin)
Vue.use(AlertPlugin)
Vue.use(ConfirmPlugin)

Vue.prototype.bus = new Vue()

if ('addEventListener' in document) {
document.addEventListener(
'DOMContentLoaded',
() => {
FastClick.attach(document.body)
},
false
)
}

Vue.filter('moment', function(value, formatString) {
formatString = formatString || 'YYYY-MM-DD'
return Moment(value).format(formatString)
})
Vue.filter('moment1', function(value, formatString) {
formatString = formatString || 'YYYY-MM-DD HH:mm:ss'
return Moment(value).format(formatString)
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
el: '#app',
router,
store,
components: { App },
template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js